export default "__VITE_ASSET__zCmI$GYO__"